import { DELIVERY, DINEIN, PICKUP, TABLE } from "../../../constants";

const OrderFilterKeys = {
    all: "all",
    online: "online",
    table: "table",
    dining: "dining",
}

export const OrderFilters = {
    [OrderFilterKeys.all]: [DELIVERY, PICKUP, DINEIN, TABLE],
    [OrderFilterKeys.online]: [DELIVERY, PICKUP],
    [OrderFilterKeys.table]: [TABLE],
    [OrderFilterKeys.dining]: [DINEIN],
}


export const FILTER_LIST = [
    { _id: OrderFilterKeys.all, name: "All Orders" },
    { _id: OrderFilterKeys.online, name: "Online Orders" },
    { _id: OrderFilterKeys.table, name: "Table Orders" },
    { _id: OrderFilterKeys.dining, name: "Dining Orders" },
];

export const DATE_FILTER_LIST = [
    { _id: "date", name: "" },
    { _id: "today", name: "Today" },
    { _id: "this_week", name: "This Week" },
    { _id: "this_month", name: "This Month" },
];

export const PAYMENT_FILTER_LIST = [
    { value: "all", label: "All" },
    { value: "incoming", label: "Incoming" },
    { value: "ready", label: "Ready" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
    { value: "placed_order", label: "Placed Order" },
    { value: "preparing", label: "Preparing" },
    { value: "pending_payment", label: "Pending Payment" },
    { value: "payment_complete", label: "Payment Complete" },
    { value: "awaiting_payment_collection", label: "Awaiting Payment Collection" },
];

export const dateFormat = "DD-MM-YYYY";
export const TitleDateFormat = "DD MMM Y";
export const FilterDateFormat = "Y-MM-DD";
export const ListDateFormat = "DD MMM Y, HH:mm A";